import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { FaLock } from 'react-icons/fa';
import { login, whoAmI } from '../../server/server';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../auth/UseUser';

const theme = createTheme();

export default function SignIn() {
  let navigate = useNavigate();
  const { setUser } = useUser();

  const [errorMessage, setErrorMessage] = React.useState('');

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const resp = await login({
      email: data.get('email') as string,
      password: data.get('password') as string,
    });
    if (resp?.status === 201) {
      const data = resp.data;

      await localStorage.setItem('accessToken', data['accessToken']);
      const token = await localStorage.getItem('accessToken');

      console.log('success login ', token);
      const response = await whoAmI();
      if (response.status === 200) {
        setUser(response.data);
        await localStorage.setItem('user', JSON.stringify(response.data));
      } else {
        console.log('who am i failed ', response.status);
      }
    } else {
      setErrorMessage(resp?.data?.message);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <FaLock />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />

            <Typography component="p" sx={{ color: 'error.main' }}>
              {errorMessage}
            </Typography>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
            <Grid container></Grid>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
